
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'UserDropdown',
  data () {
    return {
      showDropdown: false,
      savingPrivacy: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'customer/getUser',
      email: 'customer/getEmail',
      kdnr: 'customer/getKdnr',
      isEigentuemer: 'customer/isEigentuemer',
      dataSharingEnabled: 'customer/dataSharingEnabled'
    }),
    // Nicht customer/getName nutzen: liefert "undefined undefined", solange der Kunde nicht geladen ist
    fullName () {
      const firstname = this.user?.firstname || ''
      const lastname = this.user?.lastname || ''
      return `${firstname} ${lastname}`.trim()
    },
    hasName () {
      return this.fullName.length > 0
    }
  },
  mounted () {
    document.addEventListener('click', this.clickOutside)
    document.addEventListener('keydown', this.onKeydown)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.clickOutside)
    document.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    clickOutside (event) {
      const target = event.target
      const dropdown = this.$el.querySelector('.dropdown')
      const button = this.$el.querySelector('.openButton')

      // Check if the click was outside the dropdown and button
      if (dropdown && !dropdown.contains(target) && button && !button.contains(target)) {
        this.closeDropdown()
      }
    },
    onKeydown (event) {
      if (event.key === 'Escape') {
        this.closeDropdown()
      }
    },
    toggleDropdown () {
      this.showDropdown = !this.showDropdown
    },
    closeDropdown () {
      this.showDropdown = false
    },
    ...mapActions({
      resetCustomer: 'customer/resetState'
    }),
    ...mapMutations({
      updateUser: 'customer/updateUser'
    }),
    openPrivacy () {
      this.closeDropdown()
      this.$refs.privacyDialog.show()
    },
    async toggleDataSharing () {
      if (this.savingPrivacy) { return }
      const next = !this.dataSharingEnabled
      this.savingPrivacy = true
      try {
        const data = await this.$api.user.setDataSharing(next)
        const enabled = typeof data?.enabled === 'boolean' ? data.enabled : next
        this.updateUser({ data_sharing_enabled: enabled })
      } catch (e) {
        this.$alert('Einstellung konnte nicht gespeichert werden. Bitte später erneut versuchen.', true)
      } finally {
        this.savingPrivacy = false
      }
    },
    copyToClipboard (text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$alert('Kopiert: ' + text)
      }).catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Fehler beim Kopieren: ', err)
      })
    },
    async logout () {
      this.$logout()
      await this.resetCustomer()

      // redirect to https://www.credimaxx.de/login/ after logout
      window.location.href = 'https://www.credimaxx.de/login/'
    }
  }
}
